module.exports = __webpack_public_path__ + "img/smartplug-old.e77900eb.png";